<template>
  <div class="jin-product">
    <div class="jin-product-title apply-fadeInUp-el">
      <img src="~@/assets/index/product/英文装饰@2x.png" alt="">
      <div class="jin-product-title-zh">金十数据主打产品</div>
      <div class="jin-product-title-en">Jin10 Main Products</div>
    </div>
    <div class="jin-product-content">
      <div class="jin-product-content-wrap apply-fadeInUp-el">
        <div
          v-for="(item,index) in productList"
          :key="index"
          class="jin-product-content-item"
        >
          <img :src="item.icon" alt="">
          <div class="jin-product-content-item-title">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      productList: [
        {
          icon: require('@/assets/index/product/金十数据@2x.png'),
          title: '金十数据'
        },
        {
          icon: require('@/assets/index/product/交易侠@2x.png'),
          title: '交易侠'
        },
        {
          icon: require('@/assets/index/product/美港电讯@2x.png'),
          title: '美港电讯'
        },
        {
          icon: require('@/assets/index/product/金十期货@2x.png'),
          title: '金十期货'
        },
        {
          icon: require('@/assets/index/product/数鸽@2x.png'),
          title: '数鸽'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.jin-product {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
  padding-top: 82px;
  background: #fff;
  .jin-product-title {
    position: relative;
    width: 1160px;
    height: 45px;
    margin: 0 auto;
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3D4351;
    line-height: 45px;
    text-align: center;
    // opacity: 0;
    img {
      width: 100%;
      height: 68px;
    }
    .jin-product-title-zh {
      margin-top: -5px;
    }
    .jin-product-title-en {
      margin: 2px 0 4px;
      height: 27px;
      font-size: 18px;
      font-weight: 400;
      color: #787b8a;
      line-height: 27px;
    }
  }
  .jin-product-content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1600px;
    height: 495px;
    margin: 0 auto;
    background: url("~@/assets/index/product/背景素材@2x.png") no-repeat;
    background-size: 100% 100%;
    .jin-product-content-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 1160px;
      .jin-product-content-item {
        width: 120px;
        img {
          height: 120px;
        }
        .jin-product-content-item-title {
          margin-top: 20px;
          height: 24px;
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 400;
          color: #3D4351;
          line-height: 24px;
          text-align: center;
        }
      }
    }
  }
}

@media screen and (max-width: 1680px) {
  .jin-product {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    margin: 0 auto;
    padding-top: calc(82px / 1.3);
    background: #fff;
    .jin-product-title {
      position: relative;
      width: calc(1160px / 1.3);
      height: calc(45px / 1.3);
      margin: 0 auto;
      font-size: calc(30px / 1.3);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #3d4351;
      line-height: calc(45px / 1.3);
      text-align: center;
      // opacity: 0;
      img {
        width: 100%;
        height: calc(68px / 1.3);
      }
      .jin-product-title-zh {
        margin-top: calc(-5px / 1.3);
      }
      .jin-product-title-en {
        margin: calc(2px / 1.3) 0 calc(4px / 1.3);
        height: calc(27px / 1.3);
        font-size: calc(18px / 1.3);
        font-weight: 400;
        color: #787b8a;
        line-height: calc(27px / 1.3);
      }
    }
    .jin-product-content {
      display: flex;
      justify-content: center;
      align-items: center;
      width: calc(1600px / 1.3);
      min-width: 1000px;
      height: calc(495px / 1.3);
      margin: 0 auto;
      background: url("~@/assets/index/product/背景素材@2x.png") no-repeat;
      background-size: 100% 100%;
      .jin-product-content-wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: calc(1160px / 1.3);
        .jin-product-content-item {
          width: calc(120px / 1.3);
          img {
            height: calc(120px / 1.3);
          }
          .jin-product-content-item-title {
            margin-top: calc(20px / 1.3);
            height: calc(24px / 1.3);
            font-size: calc(16px / 1.3);
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 400;
            color: #3D4351;
            line-height: calc(24px / 1.3);
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
